import { css } from 'styled-components';

import { theme } from '../../common/ui/theme';

export const linkStyles = css<{ fontSize: string }>`
    font-size: ${(props) => props.fontSize};
    color: ${theme.colors.accent.foreground};
    text-decoration: none;
    font-weight: ${theme.fontWeights[500]};
    cursor: pointer;

    &:hover,
    &:focus {
        color: ${theme.colors.accent.tint};
        text-decoration: none;
    }

    &:active,
    &:visited {
        color: ${theme.colors.accent.foreground};
        text-decoration: none;
    }
`;
